<template>
	<div class="document-link">
		<BaseLink class="document-link__link display-flex align-items-center" :link="{ href: url, target: '_blank' }">
			<span class="display-block position-relative document-link__thumb">
				<span class="display-block document-link__thumb-img position-relative">
					<span class="coterminous display-flex align-items-center justify-content-center">
						<BaseSvgIcon width="20" height="20" :name="icon" />
					</span>
				</span>
			</span>
			<span class="ml-100">
				<span class="display-block heading-text-color body-lg-md"> {{ props.literature.title }}</span>
				<span class="display-block mt-25 text-color-content-secondary body-sm" :data-test="type">{{
					type
				}}</span>
			</span>
		</BaseLink>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FundLiterature } from 'types/funds';

interface Props {
	literature: FundLiterature;
}

const props = defineProps<Props>();

const isEdgarLink = computed((): boolean => props.literature.externalLink?.secFiling ?? false);

const isSanityRedirect = computed(
	(): boolean =>
		!!props.literature.externalLink?.url &&
		(props.literature.externalLink.url.includes('/sanity-documents/') ||
			props.literature.externalLink.url.includes('/documents/'))
);

// As per Sanity schema either file or external link has be added in order to publish literature item
const url = computed((): string => props.literature.file?.url ?? props.literature.externalLink?.url ?? '');

const type = computed((): string => {
	if (!!props.literature.file?.url && !!props.literature.file?.extension) {
		return `${props.literature.file.extension.toUpperCase()} attachment`;
	} else if (isSanityRedirect.value) {
		return 'PDF attachment';
	} else if (isEdgarLink.value) {
		return 'EDGAR SEC link';
	}

	return 'External link';
});

const icon = computed((): string => (props.literature.file?.url || isSanityRedirect.value ? 'pdf' : 'external-link'));
</script>
